import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import axios from "axios";
import swal from "sweetalert";
import { getURl } from "services/core";
import { Util } from "common/util";
import {
  ArrowLeftOutlined,
  CloudUploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import {
  Form,
  Button,
  Col,
  Row,
  Upload,
  Tabs
} from "common/elements";

export default function ImportForm() {
  const [display, setDisplay] = useState("");
  const [exampleTemplate, setExampleTemplate] = useState("Payroll Import Payroll Import Template.xlsx")
  const navigate = useNavigate();

  const onBack = () => {
    navigate("/payrolls");
  };

  const uploadPayrollAccrualExcelFile = (options) => {
    setDisplay("none");
    const { onSuccess, onError, file } = options;
    const formData = new FormData();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
      },
    };
    formData.append("csv", file, file.name);
    try {
      axios
        .post(`${getURl()}/payroll/v1/import_payroll_accrual`, formData, config)
        .then((response) => {
          if (response.status === 200) {
            onSuccess("Ok");
            Util.getInstance().sweetAlertMessage(t("text_success_import"), "success");
          }
        })
        .catch((err) => {
          onError({ err });
          const notFoundPayrollItems = JSON.parse(err.response.data.error.message);
          swal({
            title: "Payroll Accrual item not found",
            text: notFoundPayrollItems.join(", "),
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (err) {
      onError({ err });
      Util.getInstance().sweetAlertMessage(err.message, "error");
    }
  };

  const uploadPayrollExcelFile = (options) => {
    setDisplay("none");
    const { onSuccess, onError, file } = options;
    const formData = new FormData();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
      },
    };
    formData.append("csv", file, file.name);
    try {
      axios
        .post(`${getURl()}/payroll/v1/import?clientId=${Util.getInstance().getClientId()}`, formData, config)
        .then((response) => {
          if (response.status === 200) {
            onSuccess("Ok");
            Util.getInstance().sweetAlertMessage(t("text_success_import"), "success");
          }
        })
        .catch((err) => {
          onError({ err });
          const notFoundPayrollItems = JSON.parse(err.response.data.error.message);
          swal({
            title: "Payroll item not found",
            text: notFoundPayrollItems.join(", "),
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (err) {
      onError({ err });
      Util.getInstance().sweetAlertMessage(err.message, "error");
    }
  };

  const uploadOvertimeExcelFile = (options) => {
    setDisplay("none");
    const { onSuccess, onError, file } = options;
    const formData = new FormData();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
      },
    };
    formData.append("csv", file, file.name);
    try {
      axios
        .post(`${getURl()}/payroll/v1/import_overtime?clientId=${Util.getInstance().getClientId()}`, formData, config)
        .then((response) => {
          if (response.status === 200) {
            onSuccess("Ok");
            Util.getInstance().sweetAlertMessage(t("text_success_import"), "success");
          }
        })
        .catch((err) => {
          onError({ err });
          swal({
            title: "Opps!",
            text: err?.response?.data?.error?.message,
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (err) {
      onError({ err });
      Util.getInstance().sweetAlertMessage(err.message, "error");
    }
  };

  const handlRemove = () => {
    setDisplay("");
  }

  const onChangeTabs = (value) => {
    if (value === "ImportPayroll") {
      setExampleTemplate("Payroll Import Payroll Import Template.xlsx")
    }
    else if (value === "ImportPayrollAccrual") {
      setExampleTemplate("Payroll Import Payroll Accrual Import Template.xlsx")
    }
    else {
      setExampleTemplate("Payroll Import Overtime Import Template.xlsx")
    }
  }

  const handleBeforeUploadPayroll = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        swal({
          title: "Are you sure you want to import payroll?",
          text: "This will import the payroll for employees. Do you want to continue?",
          icon: "warning",
          buttons: ["No, cancel", "Yes, import payroll!"]
        }).then((yes) => {
          if (yes) {
            resolve(file);
          } else {
            reject();
            handlRemove();
          }
        });
      };
      reader.readAsDataURL(file);
    });
  };

  const handleBeforeUploadOvertime = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        swal({
          title: "Are you sure you want to import overtimes?",
          text: "This will import the overtimes for employees. Do you want to continue?",
          icon: "warning",
          buttons: ["No, cancel", "Yes, import!"]
        }).then((yes) => {
          if (yes) {
            resolve(file);
          } else {
            reject();
            handlRemove();
          }
        });
      };
      reader.readAsDataURL(file);
    });
  };

  const handleBeforeUploadPayrollAccrual = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        swal({
          title: "Are you sure you want to import payroll accrual?",
          text: "This will import the overtimes for payroll accrual. Do you want to continue?",
          icon: "warning",
          buttons: ["No, cancel", "Yes, import!"]
        }).then((yes) => {
          if (yes) {
            resolve(file);
          } else {
            reject();
            handlRemove();
          }
        });
      };
      reader.readAsDataURL(file);
    });
  };

  return (
    <Form layout="vertical" className="personal-form " id="import">
      <div className="btn-navigation">
        <Row>
          <Col span={12}>
            <div className="pull-left">
              <Button className="btn-import-back" onClick={() => onBack()}>
                <ArrowLeftOutlined />
                <span>{t("text_back")}</span>
              </Button>
              <span className="title">{t("text_import_employee_payroll")}</span>
            </div>
          </Col>
          <Col span={12}>
            <div className="pull-right">
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                className="btn-download-template"
              >
                <a
                  href={process.env.PUBLIC_URL + `/${exampleTemplate}`}
                  download={`${exampleTemplate}`}
                >
                  {t("text_download_template")}
                </a>
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      <Tabs defaultActiveKey="1" style={{ marginLeft: "15px" }} onChange={onChangeTabs}>
        <Tabs.TabPane tab={t("text_import_payroll")} key="ImportPayroll">

          <Upload
            accept={"application/vnd.ms-excel,.csv,.xls,.xlsx"}
            beforeUpload={handleBeforeUploadPayroll}
            customRequest={uploadPayrollExcelFile}
            className="image-upload-grid"
            maxCount={1}
            onRemove={handlRemove}
          >
            <div className="import-content" style={{ display: `${display}` }}>
              <div className="cloud-upload-icon">
                <CloudUploadOutlined />
              </div>
              <div className="text-upload">
                <span>{t("text_upload_a_spreatsheet_to_import_employees_payroll")}</span>
              </div>
              <div className="text-upload-file">
                <span>{t("text_upload_files_drag_and_drop")}</span>
              </div>
              <div className="btn-upload-file">
                <Button type="primary">
                  {t("text_choose_a_file_to_upload")}
                </Button>
              </div>
            </div>
          </Upload>

        </Tabs.TabPane>
        {/* <Tabs.TabPane tab={t("text_import_payroll_accrual")} key="ImportPayrollAccrual">
          <Upload
            accept={"application/vnd.ms-excel,.csv,.xls,.xlsx"}
            beforeUpload={handleBeforeUploadPayrollAccrual}
            customRequest={uploadPayrollAccrualExcelFile}
            className="image-upload-grid"
            maxCount={1}
            onRemove={handlRemove}
          >
            <div className="import-content" style={{ display: `${display}` }}>
              <div className="cloud-upload-icon">
                <CloudUploadOutlined />
              </div>
              <div className="text-upload">
                <span>{t("text_upload_a_spreatsheet_to_import_employees_payroll_accrual")}</span>
              </div>
              <div className="text-upload-file">
                <span>{t("text_upload_files_drag_and_drop")}</span>
              </div>
              <div className="btn-upload-file">
                <Button type="primary">
                  {t("text_choose_a_file_to_upload")}
                </Button>
              </div>
            </div>
          </Upload>
        </Tabs.TabPane> */}
        <Tabs.TabPane tab={t("text_import_overtime")} key="ImportOvertime">
          <Upload
            accept={"application/vnd.ms-excel,.csv,.xls,.xlsx"}
            beforeUpload={handleBeforeUploadOvertime}
            customRequest={uploadOvertimeExcelFile}
            className="image-upload-grid"
            maxCount={1}
            onRemove={handlRemove}
          >
            <div className="import-content" style={{ display: `${display}` }}>
              <div className="cloud-upload-icon">
                <CloudUploadOutlined />
              </div>
              <div className="text-upload">
                <span>{t("text_upload_a_spreatsheet_to_import_employees_overtime")}</span>
              </div>
              <div className="text-upload-file">
                <span>{t("text_upload_files_drag_and_drop")}</span>
              </div>
              <div className="btn-upload-file">
                <Button type="primary">
                  {t("text_choose_a_file_to_upload")}
                </Button>
              </div>
            </div>
          </Upload>
        </Tabs.TabPane>
      </Tabs>
    </Form>
  );
}
